import * as React from 'react'

interface IButtonFilledOrangeProps {
  children?: any
  onClick?: () => void
  className?: string
}

const ButtonFilledOrange = (props: IButtonFilledOrangeProps) => {
  return (
    <div
      className={`rounded py1 px2 bg-orange bold font-white cursor--pointer ${props.className}`}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  )
}

export default ButtonFilledOrange



// WEBPACK FOOTER //
// ./src/components/ui/ButtonFilledOrange.tsx